// extracted by mini-css-extract-plugin
module.exports = {"Exception":"Exception-module__Exception___wLJXM","content":"Exception-module__content___3HzHN"};